/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from 'react';

import PropTypes from 'prop-types';

import _ from 'underscore';

// REDUX
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as elementsActions from '../../redux/actions/elements';
import amplitudeAnalytics, {
  AMPLITUDE_NAV_SECTION_SECONDARY,
} from '../../shared/utilities/amplitude';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';

import styles from './ProductsCategoryFilter.module.css';



class ProductsCategoryFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.categoryElement = React.createRef();
    }

    componentDidMount() {
        const { isStickyCategories } = this.props;
        if (!isStickyCategories) setTimeout(this.getComponentPosition, 500);
        window.addEventListener('resize', this.getComponentPosition) // eslint-disable-line
        this.syncCategoryNavigationHandler();
    }


    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.getComponentPosition();
        }
    }

    componentWillUnmount() {
        this.syncCategoryNavigationHandler(null);
    }

    /**
     * Retrieves  component position based
     * on local and absolute positions
     */
    getComponentPosition = () => {
        const { setCategoriesPosition } = this.props;
        if (this.categoryElement.current) {
            const { top } = this.categoryElement.current.getBoundingClientRect();
            setCategoriesPosition(top + window.pageYOffset); // eslint-disable-line
        }
    }

    /**
     * Handles filter asset icon formatting and returns fully formatted image element
     * @param {String} product - product category unique id string
     * @returns {React.Element} returns formatted <img/> element
     */
    returnIconAsset = (product) => {
        const iconAlt = `${product}-icon`;
        let iconAsset = null;

        try {
            iconAsset = require(`./imgs/${product}.png`) || null; //eslint-disable-line
        } catch (e) {
            iconAsset = require('./imgs/boxes.png'); //eslint-disable-line
        }

        return (<img alt={iconAlt} src={iconAsset} className='hidden lg:block' />);
    }

    syncCategoryNavigationHandler = (handler = this.handleRegisteredCategoryNavigation) => {
        const { registerCategoryNavigationHandler } = this.props;
        if (registerCategoryNavigationHandler) {
            registerCategoryNavigationHandler(handler);
        }
    }

    getMenuCategories = () => {
        const { menuCategories } = this.props;
        return Array.isArray(menuCategories) ? menuCategories : [];
    }

    handleRegisteredCategoryNavigation = (anchor, options = {}) => {
        const menuCategories = this.getMenuCategories();
        const category = menuCategories.find((item) => item.anchor === anchor) || {
            anchor,
            navTitle: anchor,
        };
        return this.handleCategoryValueSetting(category, null, {
            trackAnalytics: false,
            ...options,
        });
    }

    /**
     * Handles category value setting for redux and callback values
     * @param mc
     * @param {Event} e - optional event object
     * @param options
     */
    handleCategoryValueSetting = (mc, e, options = {}) => {
        if (e) {
            e.preventDefault();
        }
        const { anchor, navTitle } = mc;
        const { onChange, setProductCategory, location } = this.props;
        const element = document.getElementById(anchor); // eslint-disable-line
        if (!element) {
            return false;
        }
        if (options.trackAnalytics !== false) {
            amplitudeAnalytics.trackClickNavSecondary({
              navElement: navTitle,
              navSection: AMPLITUDE_NAV_SECTION_SECONDARY.CATEGORIES,
              pathname: location?.pathname,
            });
        }
        // set value to redux
        setProductCategory(anchor);
        // return value to parent callback
        onChange(anchor);
        // scroll to position
        let scrollDelta = this.categoryElement.current ? this.categoryElement.current.getBoundingClientRect().height : 10;
        scrollDelta = window.innerWidth > 900 ? scrollDelta : 92;
        const yPos = element ? (element.offsetTop - scrollDelta) : null;
        const behavior = options.behavior || 'smooth';
         if (yPos || yPos === 0) window.scrollTo({ top: yPos, left: 0, behavior }); // eslint-disable-line
        return true;
    }

    render() {
        const { productCategory, mobileDarkTheme } = this.props;
        const menuCategories = this.getMenuCategories();
        const brandRefresh = isBrandRefreshEnabled();
        // removes duplicates navTitles (ie. "traditional cookies" and "deluxe cookies" both have a nav title of "cookies", only show this once)
        const alteredMenucategories = _.uniq(menuCategories, item => {
            return item.navTitle;
        })

        return (
          <div
            ref={this.categoryElement}
            className={`${styles.categoryFilterWrapper} ${mobileDarkTheme ? styles.mobileDarkTheme : null} flex items-center m-auto`}
          >
            <div className={`
                ${styles.categoryFilterContainer}
                p-0 m-0 flex justify-between w-full font-montserratMedium text-lg leading-[22px] tracking-[-0.1px]
                `}
            >
              {alteredMenucategories ? alteredMenucategories.map((mc, index) => {
                        const customIcon = index === 4 || index === 5;
                        const isChosen = mc.anchor === productCategory;
                        let textColorClass;
                        if (mobileDarkTheme) {
                          textColorClass = 'text-white dark:border-[#F6F3F7]';
                        } else if (brandRefresh) {
                          textColorClass = 'text-[#F1E8DE] dark:text-[#F1E8DE]';
                        } else {
                          textColorClass = 'dark:text-white text-dark dark:border-[#F6F3F7] border-dark';
                        }
                        let titleWeightClass;
                        if (isChosen) {
                          titleWeightClass = 'font-bold dark:font-bold';
                        } else if (brandRefresh) {
                          titleWeightClass = 'font-medium dark:font-medium';
                        } else {
                          titleWeightClass = 'font-[425] dark:font-[425] opacity-60';
                        }
                        return (
                          <a
                            key={`$product${Math.random()}`}
                            id={`menuCategorySelector-${mc.anchor}`}
                            href={`#${mc.anchor}`}
                            onClick={(e) => this.handleCategoryValueSetting(mc, e)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                this.handleCategoryValueSetting(mc, e);
                              }
                            }}
                            className={`
                                rounded-none
                                ease-in
                                ${textColorClass}
                                px-2

                                ${styles.category}
                                ${customIcon ? styles.customIcon : null}
                                ${isChosen ? styles.isChosen : null}
                            `}
                            aria-label={`Navigate to ${mc.navTitle} section`}
                          >
                            {/* {this.returnIconAsset(mc.anchor)} */}
                            <h3 className={`  ${titleWeightClass}`}>{mc.navTitle}</h3>
                          </a>
                        )
                    }) : null}
            </div>
          </div>
        )
    }
}

ProductsCategoryFilter.propTypes = {
    productCategory: PropTypes.string,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    onChange: PropTypes.func.isRequired,
    setProductCategory: PropTypes.func.isRequired,
    mobileDarkTheme: PropTypes.bool,
    setCategoriesPosition: PropTypes.func,
    isStickyCategories: PropTypes.bool,
    registerCategoryNavigationHandler: PropTypes.func,
    menuCategories: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        cardSize: PropTypes.string,
        navTitle: PropTypes.string,
        menuTitle: PropTypes.string,
        anchor: PropTypes.string
    }))
}

ProductsCategoryFilter.defaultProps = {
    mobileDarkTheme: false,
    setCategoriesPosition: null,
    isStickyCategories: false,
    productCategory: null,
    menuCategories: [],
    location: undefined,
    registerCategoryNavigationHandler: null,
}

export const mapStateToProps = state => {
    const { productCategory, isStickyCategories, menuCategories } = state.elements;
    return { productCategory, isStickyCategories, menuCategories };
}

export const mapDispatchToProps = dispatch => ({
    setProductCategory: (value) => dispatch(elementsActions.setProductCategory(value)),
    setCategoriesPosition: (value) => dispatch(elementsActions.setCategoriesPosition(value))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductsCategoryFilter),
);
